<!--
 * @Author: vince
 * @Date: 2021-09-03 14:34:32
 * @LastEditors: vince
 * @LastEditTime: 2021-09-08 10:33:17
 * @Description: 
-->
<template>
	<div class="column">
		<div class="state-bar mb-2px">
			<div class="sys-tbh">教师教学列表</div>
			<div class="space"></div>
			<div class="btt">同步深瞳优学</div>
			<el-button icon="el-icon-refresh" type="primary" size="small">同步</el-button>
		</div>
		<div style="flex:1">
			<el-table :loading="loading" :data="tableData" header-cell-class-name="tbh" style="width: 100%">
				<el-table-column prop="userName" label="教师" align="center"></el-table-column>
				<el-table-column prop="schoolYear" label="学年" align="center"></el-table-column>
				<el-table-column prop="schoolTerm" label="学期" align="center" :formatter="termFormatter"></el-table-column>
				<el-table-column prop="gradeName" label="年级" align="center"></el-table-column>
				<el-table-column prop="className" label="班级" align="center"></el-table-column>
				<el-table-column prop="disciplineName" label="学科" align="center"></el-table-column>
				<el-table-column prop="standardScore" label="标准分" align="center"></el-table-column>
				<el-table-column prop="evaluation" label="评价" align="center"></el-table-column>
				<el-table-column prop="score" label="积分" align="center"></el-table-column>

				<!-- <el-table-column prop="id" label="操作" align="center">
					<template slot-scope="scope">
						<el-button @click="onEdit(scope.row)" type="text" size="small">编辑</el-button>
						<el-popconfirm title="确定删除吗？" @confirm="onDel(scope.row)">
							<el-button slot="reference" type="text" class="danger" size="small">删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>-->
				<pagination v-if="tableData.length>0" class="mb-md mr-md" slot="append" :pageObj="filterForm"></pagination>
			</el-table>
		</div>
	</div>
</template>

<script>
import pagination from "../../components/Pagination.vue";
import { mapGetters } from "vuex";
import { postData, postJson, getData } from "../../http/fetch";
import dicSelector from "../../components/school/dicSelector.vue";
import AuthorSelector from "../../components/school/authorSelector.vue";
import schoolSelector from "../../components/school/schoolSelector.vue";
import uploader from "../../components/school/uploader.vue";

export default {
	name: "teaching",
	components: {
		uploader,
		pagination,
		dicSelector,
		AuthorSelector,
		schoolSelector
	},
	data() {
		return {
			saving: false,
			dialog: false,
			loading: false,
			filterForm: {
				current: 1,
				size: 10,
				total: 0,
				sizeList: [5, 10, 15, 20]
			},
			rankList: [],
			classifyList: [],
			tableData: [],
			newForm: {
				rankTemp: null,
				teacher: null,
				classify: null,
				id: null,
				infoCode: null,
				school: null,
				schoolCode: null,
				title: null,
				attach: []
			},
			rules: {
				rankTemp: [
					{ required: true, message: "请选择获奖级别", trigger: "change" }
				],
				school: [{ required: true, message: "请输入分值", trigger: "change" }],
				teacher: [
					{ required: true, message: "请选择获奖教师", trigger: "change" }
				],
				title: [{ required: true, message: "请输入获奖名称", trigger: "blur" }],
				awardDate: [
					{ required: true, message: "请选择获奖日期", trigger: "blur" }
				]
			}
		};
	},

	computed: {
		...mapGetters(["schoolCode", "operatorId", "schoolCodes"])
	},
	created() {
		// this.getDic("honorAwardType").then(res => {
		// 	this.classifyList = res;
		// });
		// this.getDic("level").then(res => {
		// 	this.rankList = res;
		// });
	},
	mounted() {
		this.getList();
	},
	methods: {
		termFormatter(row, column, cellValue, index) {
			let result = cellValue == 1 ? "上" : "下";
			return result;
		},

		getDic(dicType) {
			return new Promise((resolve, reject) => {
				getData("/core/dic/getDictionaryList", {
					dicType
				}).then(res => {
					if (res.length > 0) {
						res = res.map(m => {
							return {
								dicCode: m.dicCode,
								dicName: m.dicName
							};
						});
						resolve(res);
					} else {
						reject();
					}
				});
			});
		},
		getList() {
			this.loading = true;
			postJson(`teacherAwardInfo/getTeacherTeaching`, {
				pageSize: this.filterForm.size,
				pageNum: this.filterForm.current,
				schoolTerm: this.filterForm.schoolTerm,
				schoolYear: this.filterForm.schoolYear,
				schoolCodes: this.schoolCodes
			})
				.then(res => {
					this.tableData = res.records;
					this.filterForm.total = res.total;
				})
				.catch()
				.finally(() => {
					this.loading = false;
				});
		},
		onNew() {
			this.dialog = true;
		},
		onDialogClose() {
			this.newForm.attach = [];
			this.$refs.elnewForm.resetFields();
		}
	}
};
</script>

<style>
.btt {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.25);
	font-family: pfrgl;
	font-weight: 400;
	padding: 0 10px;
}
</style>